export default __webpack_public_path__ + "static/Trunk-7456cc253c7c79a351a60af3df9a1636.png";